export default __webpack_public_path__ + "static/media/spp-2.104e45ec.png";